import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
// import Polygon from 'google-map-react';
// import Geolocation from './Geolocation';
// import firebase from 'firebase';
import LocationPin from './Components/LocationPin'
import ContentView from './Components/ContentView';

import logoAflangt from "./assets/cph-high.png";
import MyLocationIcon from '@material-ui/icons/MyLocation';
import { db } from './Firebase/Firebase';
import { onValue, ref } from "firebase/database";

// import {indreBy, vandruteNord, vandruteSyd, slotsholmen, denkorte, dac} from './routes/routes'
// const allRoutes = [indreBy, vandruteNord, vandruteSyd, slotsholmen, denkorte, dac]

// import {twoKm, fiveKm, elevenKm, twelveKm} from './routes/2022/routes2022'
import {oneKm, twoKm, threeKm, fourKm, fiveKm, sixKm, sevenKm, aaa, bbb, ccc, ddd, eee, fff, ggg}  from './routes/routes2024';
import { ReffenStyle } from './maps/ReffenMapStyle';
import { CPHLightFestivalStyle } from './maps/CPHLightFestivalStyle';
// const allRoutes = [oneKm, fiveKm, elevenKm, twelveKm]
const allRoutes = [oneKm, twoKm, threeKm, fourKm, fiveKm, sixKm, sevenKm, aaa, bbb, ccc, ddd, eee, fff, ggg]

const MyPosition = (props) => {

  console.log('InfoViewClicked: ', props)
  var active = props.showingInfo && props.showingInfo.isUsersPosition

  return(
    <React.Fragment>
      <div style={{
            height: 14, 
            width: 14, 
            backgroundColor: "blueviolet", 
            borderRadius: 7,
            display: 'flex',  justifyContent:'center', alignItems:'center'
            }}>
      <div 
          style={{
            height: 12, 
            width: 12, 
            backgroundColor: active ? "aquamarine" : "#2bced6", 
            borderRadius: 6}}
            />
      </div>

      </React.Fragment>
    )
  }

const InfoView = (props) => {
  console.log('InfoView: ', props)

  return(
    <React.Fragment>
    <div
      style={{
        position: "absolute",
        padding: 10,
        minWidth: 50,
        borderTopLeftRadius:8,
        borderTopRightRadius:8,
        borderBottomLeftRadius:8,
        transform: 'translate(-90%, -90%)',
        backgroundColor: "white"
      }}
    >{props.location.isUsersPosition ? "Her er du" : props.location.location.title_dk}</div>
  </React.Fragment>
  )
}

class MapView extends Component {

  lines = []

  state = {
    user_location: null,
    message: "---.---",
    locations: [],
    showInfo: null,
    routes: null
  }

  //map focus
  static defaultProps = {
    center: {
      lat: 55.671892,
      lng: 12.5669927
    },
    zoom: 13.2
  };

  position = () => {
    navigator.geolocation.watchPosition(
      position => 
      {
        console.log("USER POSITION: ", position)
        this.setState({
        user_location: {
          latitude: position.coords.latitude, 
          longitude: position.coords.longitude
        },
        message: position.coords.longitude
      })}, 
      err => {
        console.log('Fejl ved at finde position.\nDette kan skyldes at de ikke har godkendt position fra deres browser, dette kan gøres fra indstillinger', err)
      }
        // alert('Fejl ved at finde position.\nDette kan skyldes at de ikke har godkendt position fra deres browser, dette kan gøres fra indstillinger', err)
    );
  }

  loadLocations(){
    const query = ref(db, "cph_light_festival_2026/");

    return onValue(query, (snapshot) => {
      const data = snapshot.val();
      let table = []

      if (snapshot.exists()) {
        Object.values(data).map((project) => {
          console.log(project)
          table.push(project)
          // setProjects((projects) => [...projects, project]);
        });

        this.setState({
				  locations: table
			  })
      }
    });

		// const rootRef = firebase.database().ref('cph_light_festival/');
    // rootRef.on('value', snap => {
    //   let table = []
    //     snap.forEach(childSnap => {

		// 		var values = childSnap.val()
		// 		var id = childSnap.key

		// 		// console.log(values)
		// 		table.push(values)
		// 	})

		// 	// console.log(table)

		// 	this.setState({
		// 		locations: table
		// 	})
		// })
	}

  componentDidMount(){
    
    this.loadLocations()

    this.position()
  }

  onChildClick(key, childProps){
    // console.log('_onChildClick', key, childProps)
    if (key === "user_location") {
      this.setState({
        showInfo: 
        {
          key,
          isUsersPosition: true,
          position: {lat: childProps.lat, lng: childProps.lng}
        }
      })
    } else {
      this.setState({
        showInfo: 
        {
          key: parseInt(key),
          isUsersPosition: false,
          location: childProps.location,
          position: {lat: childProps.lat, lng: childProps.lng}
        }
      })
    }

  }

  getPaths(path) {
    // const { path } = this.props

    if (path) {
      // var routeLatLng = []

      // path.coordinates.forEach(element => {
      //   if (element.length == 2) {
      //     let coord = { lat: element[1], lng: element[0]}
      //     routeLatLng.push(coord)
      //   }
      // });

      return path.coordinates
    } 

  }

  renderPolyline(color) {
    return {
      geodesic: true,
      strokeColor: color || '#ffffff',
      strokeOpacity: 1,
      strokeWeight: 4
    }
  }

  routeController = (p) => {
    this.lines.map((line)=>{
      line.setMap(null)
    })

    for (var key in p) {
      if (p.hasOwnProperty(key)) {
          // console.log(key + " -> " + p[key]);
          if (p[key]) { //true
            let showRoute = allRoutes.find((v => v.key == key))
            // console.log(showRoute);

            const Polyline = this.state.maps.Polyline
  
            const renderedPolyline = this.renderPolyline(showRoute.color)
            const paths = { path: this.getPaths(showRoute) }
        
            this.line = new Polyline(Object.assign({}, renderedPolyline, paths))
  
            this.line.setMap(this.state.map)

            this.lines.push(this.line)
            
            // return(
            //   <MyPolyline path={showRoute} color={testRoute.color} map={this.state.map} maps={this.state.maps} /> 
            // )
          }
      }
    }
  }

  render() {

    const {routes} = this.state

    // console.log('ROUTS: ', routes)

    const pathCoordinates = [
      { lat: 55.682892, lng: 12.5169927 },
      { lat: 36.2169884797185, lng: 12.5169927 }
  ];
  const triangleCoords = [
    {lat: 25.774, lng: -80.190},
    {lat: 18.466, lng: -66.118},
    {lat: 32.321, lng: -64.757},
    {lat: 25.774, lng: -80.190}
  ];
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '100vh', width: '100%' }}>
        {/* <Geolocation />
        <button onclick={this.position()}>Try It</button>
    <text>{this.state.message}</text> */}
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyABzlW3RIMa5zYLRfiRVpsOA4f0DjT7e_0" }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
          options={{styles: CPHLightFestivalStyle}}
          center={this.state.center}
          zoom={this.state.zoom}
          onGoogleApiLoaded={({ map, maps }) => { this.setState({ map: map, maps:maps, mapLoaded: true }) }}
          yesIWantToUseGoogleMapApiInternals
          onDragEnd={(map)=>{
            console.log('onDragEnd: ',map)
            this.setState({
              center: map.center,
              zoom: map.zoom
            })
          }}
          onClick={()=>
            {
              if (this.state.showInfo) {
                this.setState({showInfo: null})
              }
            }
          }
          onChildClick={(k,c)=>
            // console.log('_onChildClick', k, c)
            this.onChildClick(k,c)
          }
          // hoverDistance={5}
        >
          {/* <Polygon
          paths={triangleCoords}
          strokeColor="#0000FF"
          strokeOpacity={0.8}
          strokeWeight={2}
          fillColor="#0000FF"
          fillOpacity={0.35} /> */}

          {this.state.locations.map((loca, index)=>{
            if (!loca.latitude || !loca.latitude) {
              return
            }
            var active = this.state.showInfo && this.state.showInfo.key === index
            return(
            <LocationPin
              key={index}
              isAcive={active}
              location={loca}
              lat={parseFloat(loca.latitude)}
              lng={parseFloat(loca.longitude)}
            />)
          })}

        {this.state.user_location &&          
            <MyPosition
              key={'user_location'}
              showingInfo={this.state.showInfo}
              lat={this.state.user_location.latitude}
              lng={this.state.user_location.longitude}
            />
          } 

          {this.state.showInfo &&
            <InfoView 
            location={this.state.showInfo}
            lat={this.state.showInfo.position.lat}
            lng={this.state.showInfo.position.lng}
          />
          }
        {/* <Polyline path={testRoute}/> */}
        </GoogleMapReact>

        { this.state.mapLoaded && routes &&
          this.routeController(routes)
        }

        {/* ContentView bør rykkes én gang op til parent of så kan de dele om props */}
        <ContentView 
        allLocations={this.state.locations} 
        chosenLocation={this.state.showInfo} 
        userLocation={this.state.user_location}
        routeUpdate={(change)=>{
          console.log(change)
          this.setState({
            routes: change
          })
        }} 
        locationClick={(location)=>{
          if (location) {

            let lt = parseFloat(location.location.latitude)

            let showInfo = {
              key: 0,
              isUsersPosition: false,
              location: location.location,
              position: {lat: parseFloat(location.location.latitude), lng: parseFloat(location.location.longitude)}
            }

            this.setState({
              showInfo
            })
          } else {
            this.setState({
              showInfo: null
            })
          }

        }}
        />

        <div style={{position:"absolute", bottom: 30, left:10, right:0}}>
          <img src={logoAflangt} alt="LOGO" width="160"/>
        </div>

        {this.state.user_location &&
          <div style={{position:"absolute", bottom: 115, right: 9, backgroundColor: "gray", height: 44, width: 44, borderRadius: 22, display: 'flex',  justifyContent:'center', alignItems:'center'}}>
          <div 
          onClick={()=>{
            this.setState({
              center: {lat: this.state.user_location.latitude, lng: this.state.user_location.longitude},
              zoom: 16
            })
          }}
            style={{
              height: 42, 
              width: 42, 
              backgroundColor: "white", 
              borderRadius: 21,
              display: 'flex',  justifyContent:'center', alignItems:'center'}}
              >
                <MyLocationIcon style={{color: "gray"}} />
              </div>
          </div>
        }

        {/* {movieView()} */}
      </div>
    );
  }
}

export default MapView;